import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SPEAKING_QUESTION_LABEL_KEYS = {
  speaking: 'speakingQuestion',
  maxAttempts: 'maxAttempts',
  remainingAttempts: 'remainingAttempts',
  preparation: 'preparation',
  answer: 'answer',
  minimum: 'minimum',
  pressToStart: 'pressToStart',
  prepAndAnswerHint: 'prepAndAnswerHint',
  micPermissionHint: 'micPermissionHint',
  preparing: 'preparing',
  skipPreparation: 'skipPreparation',
  recording: 'recording',
  stopRecording: 'stopRecording',
  canStopAfter: 'canStopAfter',
  recordReady: 'recordReady',
  duration: 'duration',
  reRecord: 'reRecord',
  submitAnswer: 'submitAnswer',
  permissionDenied: 'permissionDenied',
  requestingMicPermission: 'requestingMicPermission',
  allowMicDialogHint: 'allowMicDialogHint',
  reservingAttempt: 'reservingAttempt',
  reservingAttemptHint: 'reservingAttemptHint',
  noMicPermission: 'noMicPermission',
  deniedMicPermissionHint: 'deniedMicPermissionHint',
  tryAgain: 'tryAgain',
  outOfAttemptsTitle: 'outOfAttemptsTitle',
  outOfAttemptsSubtitle: 'outOfAttemptsSubtitle',
  submittedAnswerTitle: 'submittedAnswerTitle',
  finalRecordBadge: 'finalRecordBadge',
  noAudioOnDeviceTitle: 'noAudioOnDeviceTitle',
  noAudioOnDeviceDescription: 'noAudioOnDeviceDescription',
  studentSubmissionTitle: 'studentSubmissionTitle',
  usedAttempts: 'usedAttempts',
  turnsUnit: 'turnsUnit',
  answerDuration: 'answerDuration',
  submittedAtPrefix: 'submittedAtPrefix',
  noAudioSubmittedTitle: 'noAudioSubmittedTitle',
  noAudioSubmittedDescription: 'noAudioSubmittedDescription',
  confirmReRecordTitle: 'confirmReRecordTitle',
  confirmReRecordMessage: 'confirmReRecordMessage',
  confirmSubmitTitle: 'confirmSubmitTitle',
  confirmSubmitMessage: 'confirmSubmitMessage',
  noRequirement: 'noRequirement',
  notSubmittedYet: 'notSubmittedYet',
  confirm: 'confirm',
  cancel: 'cancel'
};
export var resolveSpeakingLabel = function resolveSpeakingLabel(label) {
  return _objectSpread(_objectSpread({}, SPEAKING_QUESTION_LABEL_KEYS), label);
};

var translate = function translate(translator, key, options) {
  return translator(key, options);
};

export var buildSpeakingQuestionLabels = function buildSpeakingQuestionLabels(speakingTranslator, commonTranslator) {
  var labels = _objectSpread({}, SPEAKING_QUESTION_LABEL_KEYS);

  Object.keys(labels).forEach(function (key) {
    if (key === 'prepAndAnswerHint' || key === 'canStopAfter') return;
    labels[key] = translate(speakingTranslator, String(key));
  });
  labels.prepAndAnswerHint = translate(speakingTranslator, 'prepAndAnswerHint', {
    prep: '{{prep}}',
    speaking: '{{speaking}}'
  });
  labels.canStopAfter = translate(speakingTranslator, 'canStopAfter', {
    sec: '{{sec}}',
    min: '{{min}}'
  });
  labels.speaking = translate(speakingTranslator, 'speakingQuestion');

  if (commonTranslator) {
    labels.confirm = translate(commonTranslator, 'confirm');
    labels.cancel = translate(commonTranslator, 'cancel');
  }

  return labels;
};